import type { FilterData, SelectedNbfFilters } from '@which/shared'

import { useProductListingPageQuery } from '../../../generated/frontend'

interface FilterProps {
  categorySlug: string
  context?: string
  pageNumber?: string
  sortBy?: string
  basicFilterData?: FilterData
  needsBasedFilterData?: FilterData
  selectedNeedsBasedFilters?: SelectedNbfFilters
  channel?: string
  skip?: boolean
}

export const useCategoryFilterQuery = ({
  categorySlug,
  context = 'reviews',
  pageNumber = '1',
  sortBy = '',
  basicFilterData = {},
  needsBasedFilterData = {},
  selectedNeedsBasedFilters = {},
  channel = 'deliver',
  skip = false,
}: FilterProps) => {
  const { loading, error, data, fetchMore } = useProductListingPageQuery({
    variables: {
      categorySlug,
      context,
      pageNumber,
      sortBy,
      basicFilterData,
      needsBasedFilterData,
      selectedNeedsBasedFilters,
      channel,
    },
    skip,
  })

  if (loading) {
    return { loading, error, productsWithPagination: undefined, totalProductCount: 0, fetchMore }
  }

  if (error) {
    console.warn('Error fetching category filter data:', error)
    return { loading, error, productsWithPagination: undefined, totalProductCount: 0, fetchMore }
  }

  const productsWithPagination = data?.productListingPage?.productsWithPagination
  const totalProductCount = productsWithPagination?.productCount?.total || 0

  return {
    loading,
    error,
    productsWithPagination,
    totalProductCount,
    fetchMore,
  }
}
